import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-switch-toggle-checkbox',
  templateUrl: './switch-toggle-checkbox.component.html',
  styleUrls: ['./switch-toggle-checkbox.component.scss']
})
export class SwitchToggleCheckboxComponent implements OnInit {

  @Input() isOn: boolean;
  @Output() isOnChange = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  changeCheckbox(){
    this.isOn = !this.isOn;
    this.isOnChange.emit(this.isOn)
  }

}
